export default __webpack_public_path__ + "static/0xMaki@2x-f0b3499cd6d85bcdba0d57f0bec9afb7.jpg";